import {
  Component,
  Input,
} from '@angular/core';
import {LookupService} from "../../srvs/lookup";

@Component({
  selector: 'micro-db2SmsConfig-lookup',
  templateUrl: './micro-db2SmsConfig-lookup.component.html'
})
export class MicroDb2SmsConfigLookupComponent {

  @Input()
  configId:any;

  @Input()
  link:boolean = true;
}
